<i
  nz-icon
  nzType="question-circle"
  nzTheme="outline"
  nz-tooltip
  [nzTooltipTitle]="tooltipMessage"
></i>
